import React from 'react'
import "./Nav.css"
import fliqaIndia from '../images/png/FliqaIndiaLogo1.png';
const Nav=()=> {
  return (
    
        <div className="container">
            <div className='navlist'> 
              <ul>
                <a href=""><img src={fliqaIndia} alt="image not found"/></a>
                <a href=""><li>Home</li></a>
                <a href=""><li>Service</li></a>
                <a href=""><li>Portfolio</li></a>
                <a href=""><li>Community</li></a>
                <a href=""><li>Blog</li></a>
              </ul>
            </div>
            <div className='navSign'>
                <button type="submit">Sign UP</button>
                <button type="submit">Sign In</button>
            </div>
         
        </div>

  )
}
export {Nav};
